angular.module('SpidApp')

.constant('OrderStatusAdapterConfig', {
  name : 'OrderStatus',
  fields : [
    {
      local   : 'status',
      distant : 'status_id'
    }, {
      local   : 'updated_at',
      distant : 'updated_at'
    }, {
      local   : 'agency_id',
      distant : 'agency_id'
    }, {
      local   : 'order_id',
      distant : 'order_id'
    }, {
      local   : 'lot',
      distant : 'lot'
    }, {
    	local   : 'user',
        distant : 'user'
      }
  ]
})